import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["justifiButton", "plaidButton", "justifiContent", "plaidContent", "plaidTermsCheckbox", "plaidConnectButton"];

  connect() {
    // Justifi is selected by default
    this.selectJustifi();
  }

  selectJustifi() {
    // Update button styles
    this.justifiButtonTarget.classList.add("tw-bg-white", "tw-text-gray-900", "tw-shadow-sm");
    this.justifiButtonTarget.classList.remove("tw-text-gray-500");

    this.plaidButtonTarget.classList.remove("tw-bg-white", "tw-text-gray-900", "tw-shadow-sm");
    this.plaidButtonTarget.classList.add("tw-text-gray-500");

    // Show/hide content
    this.justifiContentTarget.classList.remove("tw-hidden");
    this.plaidContentTarget.classList.add("tw-hidden");

    // Reset Plaid checkbox when switching away
    if (this.hasPlaidTermsCheckboxTarget) {
      this.plaidTermsCheckboxTarget.checked = false;
      this.updatePlaidButtonState();
    }
  }

  selectPlaid() {
    // Update button styles
    this.plaidButtonTarget.classList.add("tw-bg-white", "tw-text-gray-900", "tw-shadow-sm");
    this.plaidButtonTarget.classList.remove("tw-text-gray-500");

    this.justifiButtonTarget.classList.remove("tw-bg-white", "tw-text-gray-900", "tw-shadow-sm");
    this.justifiButtonTarget.classList.add("tw-text-gray-500");

    // Show/hide content
    this.plaidContentTarget.classList.remove("tw-hidden");
    this.justifiContentTarget.classList.add("tw-hidden");

    // Update Plaid button state based on checkbox
    this.updatePlaidButtonState();
  }

  handlePlaidTermsChange() {
    this.updatePlaidButtonState();
  }

  updatePlaidButtonState() {
    if (!this.hasPlaidTermsCheckboxTarget || !this.hasPlaidConnectButtonTarget) {
      return;
    }

    const isChecked = this.plaidTermsCheckboxTarget.checked;
    this.plaidConnectButtonTarget.disabled = !isChecked;

    if (isChecked) {
      this.plaidConnectButtonTarget.classList.remove('tw-opacity-50', 'tw-cursor-not-allowed');
      this.plaidConnectButtonTarget.classList.add('hover:tw-bg-teal-800');
    } else {
      this.plaidConnectButtonTarget.classList.add('tw-opacity-50', 'tw-cursor-not-allowed');
      this.plaidConnectButtonTarget.classList.remove('hover:tw-bg-teal-800');
    }
  }
}
